export default __webpack_public_path__ + "static/media/Franja-Internas.0b624509.jpg";